import { Formik } from 'formik';
import * as Yup from 'yup';
import { exportAuditLogs } from '../../../../api/requests';
import { useState } from 'react';
import { showToast } from '../../../../utils/miscFunctions';
import useUserAccount from '../../../../hooks/userAccountHook';
import { User } from '../../../../models/User';
import SelectDropdown from '../../../../components/form-control/SelectDropdown';
import Button from '../../../../components/form-control/Button';
import Input from '../../../../components/form-control/Input';

interface IAuditLogsProps {
  onProceed: (data: any) => void;
  onClose: () => void;
  admins: any;
}

interface IFormData {
  staff?: number;
  maxRecords: number;
  search?: string;
}

const ExportAuditLogs = ({ onProceed, onClose, admins }: IAuditLogsProps) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { getProfile } = useUserAccount();
  const user = new User(getProfile());
  const submitHandler = (values: IFormData) => {
    setSubmitting(true);

    const staff = values.staff;
    const maxRecords = values.maxRecords;
    const search = values.search;

    exportAuditLogs(maxRecords, search, staff)
      .then((response: any) => {
        onClose();
        showToast.success(response?.message);
      })
      .catch((response: any) => {
        showToast.error(response?.description);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <>
      <Formik
        initialValues={{
          staff: undefined,
          maxRecords: 500,
          search: '',
        }}
        validateOnBlur
        validationSchema={Yup.object().shape({
          maxRecords: Yup.number().required("Maximum record size is required"),
        })}
        onSubmit={(values) => {
          submitHandler(values);
        }}>
        {({
          values,
          errors,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          touched
        }) => (
          <form className="px-4 py-[30px] bg-white dark:bg-darkBg space-y-4 rounded-xl" onSubmit={handleSubmit}>
            <Input
              type="number"
              name="maxRecords"
              label="Maximum record size"
              placeholder=""
              className="rounded-[0px] placeholder-[#848484] focus:ring-primary-border px-3"
              value={values?.maxRecords}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.maxRecords ? errors.maxRecords : undefined}
              helperText={touched?.maxRecords ? errors.maxRecords : undefined}
              required
            />
            <Input
              type="text"
              name="search"
              label="Search"
              placeholder="Search"
              className="rounded-[0px] placeholder-[#848484] focus:ring-primary-border px-3"
              value={values?.search}
              onChange={handleChange}
              onBlur={handleBlur}
            // error={touched.search ? errors.search : undefined}
            // helperText={touched?.search ? errors.search : undefined}
            // required
            />

            <SelectDropdown
              name="staff"
              label="Select manager"
              listSelectedValue={values.staff}
              onChange={(value: string) => {
                setFieldValue('staff', value);
              }}
              list={admins}
            // error={touched.staff ? errors.staff : undefined}
            // helperText={touched.staff ? errors.staff : undefined}
            />


            <div className="w-full flex gap-4 mt-6 !mb-4">
              <Button
                type="button"
                label="Cancel"
                onClick={onClose}
                bgColor='secondary'
                fullWidth
                disabled={submitting}
              />
              <Button
                label="Submit"
                onClick={handleSubmit}
                bgColor='primary'
                fullWidth
                loading={submitting}
                disabled={submitting}
              />
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default ExportAuditLogs;
